import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../Button'
import { FormGroup } from '../FormGroup'
import { Input } from '../Input'

interface MagicLinkConfirmEmailFormProps {
  onConfirm: (email: string) => void
  errorMessage?: string
  isSubmitting?: boolean
}

export const MagicLinkConfirmEmailForm: React.FC<MagicLinkConfirmEmailFormProps> = ({
  onConfirm,
  errorMessage,
  isSubmitting
}) => {
  const { t } = useTranslation()

  const [email, setEmail] = useState('')

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()

    if (!email || isSubmitting) {
      return
    }

    onConfirm(email)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <p className="text-neutralBlack-500">{t('magicLink.confirmEmailDescription', { ns: 'auth' })}</p>

      <FormGroup label={t('emailInput.label', { ns: 'auth' })}>
        <Input
          value={email}
          onChange={(event: { target: { value: string } }) => setEmail(event.target.value)}
          block
          placeholder={t('emailInput.placeholder', { ns: 'auth' })}
          type="email"
          autoComplete="email"
          required
        />
        {errorMessage ? <div className="text-danger mt-3">{errorMessage}</div> : null}
      </FormGroup>

      <Button
        type="submit"
        variant="primary"
        size="large"
        label={t('magicLink.confirmEmail', { ns: 'auth' })}
        disabled={isSubmitting}
        block
      />
    </form>
  )
}
